import React from "react";
import Styles from './styles.module.scss';
import {useSelector} from "react-redux";
import {Trans, useTranslation} from "react-i18next";
import {formatNumber} from "../cabinetShell/config";

import heroArt from '../../theme/assets/redesign/contests/hero.webp';
import treasuryImg from '../../theme/assets/redesign/contests/stat_treasury.webp';
import ticketsImg from '../../theme/assets/redesign/contests/stat_tickets.webp';
import placesImg from '../../theme/assets/redesign/contests/stat_places.webp';
import chanceImg from '../../theme/assets/redesign/contests/stat_chance.webp';


// Шапка «Giveaway» + плитки статистики (макеты 2427:4202 / 2464:8832)
const CabinetContestMain = () => {
    const {t} = useTranslation();
    const contestInfo = useSelector(store => store.cabinet.contestInfo);

    const stats = [
        {key: 'treasury', img: treasuryImg, label: t('Всего денег в казне'), value: `$${formatNumber(contestInfo?.total_money)}`},
        {key: 'tickets', img: ticketsImg, label: t('Количество билетов'), value: formatNumber(contestInfo?.tickets, 0)},
        {key: 'places', img: placesImg, label: t('Всего мест'), value: formatNumber(contestInfo?.total_places, 0)},
        {key: 'chance', img: chanceImg, label: t('Ваш шанс на победу'), value: `${formatNumber(contestInfo?.winning_percentage)}%`},
    ];

    const statsEl = (
        <div className={Styles.stats}>
            {stats.map(s => (
                <div className={Styles.stat} key={s.key}>
                    <div className={Styles.statImage}>
                        <img src={s.img} alt=""/>
                    </div>
                    <div className={Styles.statText}>
                        <div className={Styles.statLabel}>{s.label}:</div>
                        <div className={Styles.statValue}>{s.value}</div>
                    </div>
                </div>
            ))}
        </div>
    );

    return (
        <>
            <section className={Styles.hero}>
                <div className={Styles.heroArt}>
                    <img src={heroArt} alt=""/>
                </div>
                <div className={Styles.copy}>
                    <div className={Styles.title}>{t('Розыгрыш')}</div>
                    <p className={Styles.text}>
                        <Trans
                            i18nKey="giveawayDescription"
                            defaults="<b>30%</b> прибыли компании с каждого круга направляется на розыгрыш среди всех покупателей токенов в текущем раунде. Случайным образом выбираются 20 победителей, которые получают повышенные призы. Оставшаяся часть фонда распределяется между другими участниками — каждый получает минимальный денежный приз, эквивалентный стоимости одного токена текущего круга, до полного использования всей суммы."
                            components={{b: <b/>}}
                        />
                    </p>
                </div>
                <div className={Styles.desktopOnly}>{statsEl}</div>
            </section>
            <div className={Styles.mobileOnly}>{statsEl}</div>
        </>
    );
};

export default CabinetContestMain;
